import { render, staticRenderFns } from "./CustList.vue?vue&type=template&id=2ccc16a7&scoped=true&"
import script from "./CustList.vue?vue&type=script&lang=js&"
export * from "./CustList.vue?vue&type=script&lang=js&"
import style0 from "./CustList.vue?vue&type=style&index=0&id=2ccc16a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccc16a7",
  null
  
)

export default component.exports